(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $dIxxU = parcelRequire("dIxxU");
var $d4b97cf4e3084367$exports = {};

$parcel$export($d4b97cf4e3084367$exports, "extract", function () { return $d4b97cf4e3084367$export$f9380c9a627682d3; });
$parcel$export($d4b97cf4e3084367$exports, "parse", function () { return $d4b97cf4e3084367$export$98e6a39c04603d36; });
$parcel$export($d4b97cf4e3084367$exports, "stringify", function () { return $d4b97cf4e3084367$export$fac44ee5b035f737; });
$parcel$export($d4b97cf4e3084367$exports, "parseUrl", function () { return $d4b97cf4e3084367$export$7a5253c0f62e0150; });
$parcel$export($d4b97cf4e3084367$exports, "stringifyUrl", function () { return $d4b97cf4e3084367$export$a8c1621ea79325d3; });
$parcel$export($d4b97cf4e3084367$exports, "pick", function () { return $d4b97cf4e3084367$export$357523c63a2253b9; });
$parcel$export($d4b97cf4e3084367$exports, "exclude", function () { return $d4b97cf4e3084367$export$44c361b8ec72ef7f; });
const $e3f49fb9a7fe1f8f$var$token = '%[a-f0-9]{2}';
const $e3f49fb9a7fe1f8f$var$singleMatcher = new RegExp('(' + $e3f49fb9a7fe1f8f$var$token + ')|([^%]+?)', 'gi');
const $e3f49fb9a7fe1f8f$var$multiMatcher = new RegExp('(' + $e3f49fb9a7fe1f8f$var$token + ')+', 'gi');
function $e3f49fb9a7fe1f8f$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch  {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    const left = components.slice(0, split);
    const right = components.slice(split);
    return Array.prototype.concat.call([], $e3f49fb9a7fe1f8f$var$decodeComponents(left), $e3f49fb9a7fe1f8f$var$decodeComponents(right));
}
function $e3f49fb9a7fe1f8f$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch  {
        let tokens = input.match($e3f49fb9a7fe1f8f$var$singleMatcher) || [];
        for(let i = 1; i < tokens.length; i++){
            input = $e3f49fb9a7fe1f8f$var$decodeComponents(tokens, i).join('');
            tokens = input.match($e3f49fb9a7fe1f8f$var$singleMatcher) || [];
        }
        return input;
    }
}
function $e3f49fb9a7fe1f8f$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    const replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    let match = $e3f49fb9a7fe1f8f$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch  {
            const result = $e3f49fb9a7fe1f8f$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e3f49fb9a7fe1f8f$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    const entries = Object.keys(replaceMap);
    for (const key of entries)// Replace all decoded components
    input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    return input;
}
function $e3f49fb9a7fe1f8f$export$2e2bcd8739ae039(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch  {
        // Fallback to a more advanced decoder
        return $e3f49fb9a7fe1f8f$var$customDecodeURIComponent(encodedURI);
    }
}


function $e85104af5636d4bb$export$ff05df6c2df24b52(object, predicate) {
    const result = {};
    if (Array.isArray(predicate)) for (const key of predicate){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor?.enumerable) Object.defineProperty(result, key, descriptor);
    }
    else // `Reflect.ownKeys()` is required to retrieve symbol properties
    for (const key of Reflect.ownKeys(object)){
        const descriptor = Object.getOwnPropertyDescriptor(object, key);
        if (descriptor.enumerable) {
            const value = object[key];
            if (predicate(key, value, object)) Object.defineProperty(result, key, descriptor);
        }
    }
    return result;
}
function $e85104af5636d4bb$export$e87405134ad524be(object, predicate) {
    if (Array.isArray(predicate)) {
        const set = new Set(predicate);
        return $e85104af5636d4bb$export$ff05df6c2df24b52(object, (key)=>!set.has(key));
    }
    return $e85104af5636d4bb$export$ff05df6c2df24b52(object, (key, value, object)=>!predicate(key, value, object));
}


function $e78c9bd53c92ef94$export$2e2bcd8739ae039(string, separator) {
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (string === '' || separator === '') return [];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
}


const $d4b97cf4e3084367$var$isNullOrUndefined = (value)=>value === null || value === undefined;
// eslint-disable-next-line unicorn/prefer-code-point
const $d4b97cf4e3084367$var$strictUriEncode = (string)=>encodeURIComponent(string).replaceAll(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);
const $d4b97cf4e3084367$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $d4b97cf4e3084367$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            '[',
                            $d4b97cf4e3084367$var$encode(index, options),
                            ']=',
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            '[]=',
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            ':list=',
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSeparator = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $d4b97cf4e3084367$var$encode(key, options),
                                keyValueSeparator,
                                $d4b97cf4e3084367$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $d4b97cf4e3084367$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $d4b97cf4e3084367$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $d4b97cf4e3084367$var$encode(key, options),
                            '=',
                            $d4b97cf4e3084367$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $d4b97cf4e3084367$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)]$/.exec(key);
                key = key.replace(/\[\d*]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[])$/.exec(key);
                key = key.replace(/\[]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    value
                ];
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $d4b97cf4e3084367$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $d4b97cf4e3084367$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$d4b97cf4e3084367$var$decode(item, options)) : value === null ? value : $d4b97cf4e3084367$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[])$/.test(key);
                key = key.replace(/\[]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $d4b97cf4e3084367$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : $d4b97cf4e3084367$var$decode(value, options).split(options.arrayFormatSeparator);
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [
                    ...accumulator[key],
                    ...arrayValue
                ];
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [
                    ...[
                        accumulator[key]
                    ].flat(),
                    value
                ];
            };
    }
}
function $d4b97cf4e3084367$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $d4b97cf4e3084367$var$encode(value, options) {
    if (options.encode) return options.strict ? $d4b97cf4e3084367$var$strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function $d4b97cf4e3084367$var$decode(value, options) {
    if (options.decode) return (0, $e3f49fb9a7fe1f8f$export$2e2bcd8739ae039)(value);
    return value;
}
function $d4b97cf4e3084367$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $d4b97cf4e3084367$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $d4b97cf4e3084367$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $d4b97cf4e3084367$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $d4b97cf4e3084367$var$parseValue(value, options, type) {
    if (type === 'string' && typeof value === 'string') return value;
    if (typeof type === 'function' && typeof value === 'string') return type(value);
    if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) return value.toLowerCase() === 'true';
    if (type === 'number' && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return Number(value);
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') return Number(value);
    return value;
}
function $d4b97cf4e3084367$export$f9380c9a627682d3(input) {
    input = $d4b97cf4e3084367$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $d4b97cf4e3084367$export$98e6a39c04603d36(query, options) {
    options = {
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false,
        types: Object.create(null),
        ...options
    };
    $d4b97cf4e3084367$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $d4b97cf4e3084367$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const returnValue = Object.create(null);
    if (typeof query !== 'string') return returnValue;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return returnValue;
    for (const parameter of query.split('&')){
        if (parameter === '') continue;
        const parameter_ = options.decode ? parameter.replaceAll('+', ' ') : parameter;
        let [key, value] = (0, $e78c9bd53c92ef94$export$2e2bcd8739ae039)(parameter_, '=');
        if (key === undefined) key = parameter_;
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $d4b97cf4e3084367$var$decode(value, options);
        formatter($d4b97cf4e3084367$var$decode(key, options), value, returnValue);
    }
    for (const [key, value] of Object.entries(returnValue)){
        if (typeof value === 'object' && value !== null && options.types[key] !== 'string') for (const [key2, value2] of Object.entries(value)){
            const type = options.types[key] ? options.types[key].replace('[]', '') : undefined;
            value[key2] = $d4b97cf4e3084367$var$parseValue(value2, options, type);
        }
        else if (typeof value === 'object' && value !== null && options.types[key] === 'string') returnValue[key] = Object.values(value).join(options.arrayFormatSeparator);
        else returnValue[key] = $d4b97cf4e3084367$var$parseValue(value, options, options.types[key]);
    }
    if (options.sort === false) return returnValue;
    // TODO: Remove the use of `reduce`.
    // eslint-disable-next-line unicorn/no-array-reduce
    return (options.sort === true ? Object.keys(returnValue).sort() : Object.keys(returnValue).sort(options.sort)).reduce((result, key)=>{
        const value = returnValue[key];
        result[key] = Boolean(value) && typeof value === 'object' && !Array.isArray(value) ? $d4b97cf4e3084367$var$keysSorter(value) : value;
        return result;
    }, Object.create(null));
}
function $d4b97cf4e3084367$export$fac44ee5b035f737(object, options) {
    if (!object) return '';
    options = {
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        ...options
    };
    $d4b97cf4e3084367$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $d4b97cf4e3084367$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $d4b97cf4e3084367$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const [key, value] of Object.entries(object))if (!shouldFilter(key)) objectCopy[key] = value;
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $d4b97cf4e3084367$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $d4b97cf4e3084367$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $d4b97cf4e3084367$var$encode(key, options) + '=' + $d4b97cf4e3084367$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
}
function $d4b97cf4e3084367$export$7a5253c0f62e0150(url, options) {
    options = {
        decode: true,
        ...options
    };
    let [url_, hash] = (0, $e78c9bd53c92ef94$export$2e2bcd8739ae039)(url, '#');
    if (url_ === undefined) url_ = url;
    return {
        url: url_?.split('?')?.[0] ?? '',
        query: $d4b97cf4e3084367$export$98e6a39c04603d36($d4b97cf4e3084367$export$f9380c9a627682d3(url), options),
        ...options && options.parseFragmentIdentifier && hash ? {
            fragmentIdentifier: $d4b97cf4e3084367$var$decode(hash, options)
        } : {}
    };
}
function $d4b97cf4e3084367$export$a8c1621ea79325d3(object, options) {
    options = {
        encode: true,
        strict: true,
        [$d4b97cf4e3084367$var$encodeFragmentIdentifier]: true,
        ...options
    };
    const url = $d4b97cf4e3084367$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $d4b97cf4e3084367$export$f9380c9a627682d3(object.url);
    const query = {
        ...$d4b97cf4e3084367$export$98e6a39c04603d36(queryFromUrl, {
            sort: false
        }),
        ...object.query
    };
    let queryString = $d4b97cf4e3084367$export$fac44ee5b035f737(query, options);
    queryString &&= `?${queryString}`;
    let hash = $d4b97cf4e3084367$var$getHash(object.url);
    if (typeof object.fragmentIdentifier === 'string') {
        const urlObjectForFragmentEncode = new URL(url);
        urlObjectForFragmentEncode.hash = object.fragmentIdentifier;
        hash = options[$d4b97cf4e3084367$var$encodeFragmentIdentifier] ? urlObjectForFragmentEncode.hash : `#${object.fragmentIdentifier}`;
    }
    return `${url}${queryString}${hash}`;
}
function $d4b97cf4e3084367$export$357523c63a2253b9(input, filter, options) {
    options = {
        parseFragmentIdentifier: true,
        [$d4b97cf4e3084367$var$encodeFragmentIdentifier]: false,
        ...options
    };
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $d4b97cf4e3084367$export$7a5253c0f62e0150(input, options);
    return $d4b97cf4e3084367$export$a8c1621ea79325d3({
        url: url,
        query: (0, $e85104af5636d4bb$export$ff05df6c2df24b52)(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
}
function $d4b97cf4e3084367$export$44c361b8ec72ef7f(input, filter, options) {
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $d4b97cf4e3084367$export$357523c63a2253b9(input, exclusionFilter, options);
}


var $cdd664d6f9e47004$export$2e2bcd8739ae039 = $d4b97cf4e3084367$exports;


const $2f70730b9acc4592$var$parsed = (0, $cdd664d6f9e47004$export$2e2bcd8739ae039).parse(location.search);
window.onload = ()=>{
    $2f70730b9acc4592$var$on_resize();
    let utm_campaign = $2f70730b9acc4592$var$parsed.src || "";
    window.fpg_report_event = $2f70730b9acc4592$var$report_event;
    if (!utm_campaign && ($2f70730b9acc4592$var$parsed.gclid || $2f70730b9acc4592$var$parsed.gad_source)) utm_campaign = "gclid";
    if (utm_campaign) {
        var href = `https://store.steampowered.com/app/3422700/Cribbish?utm_source=website&utm_campaign=${utm_campaign}&utm_medium=web`;
        document.getElementById("steam_store_link").href = href;
        document.getElementById("steam_store_link2").href = href;
        document.getElementById("steam_store_link3").href = href;
        $2f70730b9acc4592$var$report_landing(`landing_${utm_campaign}`);
        setTimeout(()=>{
            $2f70730b9acc4592$var$report_event(`${utm_campaign}_stayed_20`);
        }, 20000);
    } else $2f70730b9acc4592$var$report_landing("landing");
};
window.onresize = (ev)=>{
    $2f70730b9acc4592$var$on_resize();
};
screen.orientation.addEventListener("change", (event)=>{
    $2f70730b9acc4592$var$on_resize();
});
function $2f70730b9acc4592$var$on_resize() {
// document.getElementById("dbg").innerText = `width: ${window.innerWidth}, height: ${window.innerHeight}`
}
function $2f70730b9acc4592$var$report_landing(landing_name) {
    const HOST_URL = "https://rw3xsm6wf5.execute-api.us-west-2.amazonaws.com/default/cribbish_beta";
    var data = {
        action: "report_landing",
        property: "fpg",
        landing_name: landing_name,
        query_string: location.search,
        cohort: new Date().toISOString().slice(0, 10)
    };
    (0, $dIxxU.default).post(HOST_URL, data).then((response)=>{
        console.log("Landing reported successfully:", response.data);
    }).catch((error)=>{
        console.error("Error reporting Landing:", error);
    });
}
function $2f70730b9acc4592$var$report_event(event_name) {
    if (event_name === 'steam_store_link1' || event_name === 'steam_store_link2') {
        function gtag() {
            window.dataLayer.push(arguments);
        }
        gtag('event', 'conversion', {
            'send_to': 'AW-17023452349/jHTfCMbxsLsaEL2JtbU_',
            'value': 1.0,
            'currency': 'USD',
            'transaction_id': ''
        });
    }
    const HOST_URL = "https://rw3xsm6wf5.execute-api.us-west-2.amazonaws.com/default/cribbish_beta";
    var data = {
        action: "report_stat",
        stat_group: "fpg",
        stat_name: event_name,
        incr_val: 1,
        cohort: new Date().toISOString().slice(0, 10)
    };
    console.log("reporting event", event_name);
    (0, $dIxxU.default).post(HOST_URL, data).then((response)=>{
        console.log("Event reported successfully:", response.data);
    }).catch((error)=>{
        console.error("Error reporting event:", error);
    });
    return true;
}

})();
//# sourceMappingURL=catandmouse.d6af2f0c.js.map
